<template>
  <div class="information__wrapper">
    <div class="information__logo">
      <r-logo />
    </div>
    <div class="information__content">
      <div class="information__title">
        <r-title style="margin-bottom: 4px;">
          {{ $t("information:title-1") }}</r-title
        >
        <r-title> {{ $t("information:title-2") }}</r-title>
      </div>
      <div class="information__сoat-of-arms chelyabinsk" />
      <div class="information__footer">
        <r-text>
          {{ $t("information:footer-apluss") }}
        </r-text>
        <r-text type="caption">
          {{ $t("information:footer-simetra") }}
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.information {
  margin-top: -15px;
  &__wrapper,
  &__content,
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__logo {
    height: 90px;
    width: 76px;
    margin-bottom: 16px;
  }
  &__title {
    margin-bottom: 4px;
    text-align: center;
  }
  &__privacy {
    margin: 16px;

    .r-link {
      font-size: 11px !important;
    }
  }
  &__footer {
    .r-text.caption-2 {
      margin-top: 4px;
    }
  }
  &__сoat-of-arms {
    margin: 8px 0;
    display: block;
    height: 140px;
    width: 140px;
    background-size: 75%;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    &.chelyabinsk {
      background-image: url("../../../assets/images/logo/chelyabinsk.png");
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "information:title-1": "Цифровая платформа RITM",
    "information:title-2": "ИТС г. Челябинск",
    "information:footer-apluss": "© 2019 ООО «А+С Транспроект»",
    "information:footer-simetra": "Powered by Simetra®"
  },
  "en": {
    "information:title-1": "RITM Digital Platform",
    "information:title-2": "ITS Chelyabinsk",
    "information:footer-apluss": "© 2019 ООО «А+С Транспроект»",
    "information:footer-simetra": "Powered by Simetra®"
  }
}
</i18n>
